import * as Yup from 'yup'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { isFormArrayFieldsEqual } from '../../../utils/formHelpers'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'
import { toLabelSelectItem } from '../../Label'

import {
  REQUEST_EDIT_LABEL_FORM_INITIAL_VALUES,
  REQUEST_EDIT_LABEL_FORM_LABEL_FIELD,
} from './RequestEditLabelModal.constants'

export function getRequestEditLabelModalValidationSchema(
  initialValues,
  itemAction
) {
  return Yup.object({
    [REQUEST_EDIT_LABEL_FORM_LABEL_FIELD]: Yup.array().when(
      FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
      {
        is: actionType =>
          !isRemoveAllEntityActionType(actionType) && !itemAction,
        then: schema => schema.of(Yup.object()).min(1, true),
      }
    ),
  }).when(EMPTY_LIST, {
    is: () => itemAction,
    then: schema =>
      schema.concat(
        formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormArrayFieldsEqual,
          isEqualProps: { name: REQUEST_EDIT_LABEL_FORM_LABEL_FIELD },
        })
      ),
  })
}

export function getRequestEditLabelModalInitialValues({
  itemAction,
  values,
} = EMPTY_OBJECT) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...REQUEST_EDIT_LABEL_FORM_INITIAL_VALUES,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: itemAction
      ? actionTypeOptions[EntityActionTypeSelectOptionValue.Edit]
      : actionTypeOptions[EntityActionTypeSelectOptionValue.Add],
    [REQUEST_EDIT_LABEL_FORM_LABEL_FIELD]:
      values?.map(toLabelSelectItem) || EMPTY_LIST,
  }
}

export function getRequestEditLabelModalPayload(values) {
  const payload = {
    ids: values[REQUEST_EDIT_LABEL_FORM_LABEL_FIELD].map(item => item.value),
  }

  return payload
}
